export default __webpack_public_path__ + "static/media/div.1d2b8868.png";